'use client';

import React, { useRef, useState, useEffect } from 'react';
import { Typography, Link } from '@mui/material';
import { useTranslation } from '@/kit/useTranslation';

const ExpandableText = ({ children, lines = 3, variant = 'body2', sx = {} }) => {
  const { t } = useTranslation();
  const contentRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [truncated, setTruncated] = useState(false);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const clone = el.cloneNode(true);
    clone.style.position = 'absolute';
    clone.style.visibility = 'hidden';
    clone.style.height = 'auto';
    clone.style.display = '-webkit-box';
    clone.style.WebkitLineClamp = String(lines);
    clone.style.WebkitBoxOrient = 'vertical';
    clone.style.overflow = 'hidden';
    document.body.appendChild(clone);
    const isTruncated = clone.scrollHeight > clone.clientHeight;
    setTruncated(isTruncated);
    document.body.removeChild(clone);
  }, [children, lines]);

  return (
    <div>
      <Typography
        ref={contentRef}
        variant={variant}
        sx={{
          ...(expanded
            ? { whiteSpace: 'normal' }
            : {
                display: '-webkit-box',
                WebkitLineClamp: lines,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }),
          ...sx,
        }}
      >
        {children}
      </Typography>
      {truncated && (
        <Link
          component="button"
          variant="caption"
          onClick={() => setExpanded((s) => !s)}
          sx={{ mt: 0.5, display: 'inline-block' }}
        >
          {expanded ? t('common.showLess') : t('common.showMore')}
        </Link>
      )}
    </div>
  );
};

export default ExpandableText;
